'use strict';
var React = require('react');
var FormatMessage = require('react-globalize').FormatMessage;

// var ESignEN = require('../public/documents/e-signEN.js');
// var ESignES = require('../public/documents/e-signES.js');

var SectionList = React.createClass({

  /**
   * @return {object}
   */
  render: function () {
    return <div>
      <FormatMessage locale={this.props.locale} path="compliancePage/customerDescription2" /><br /><br />
      <div className="row">
        <div className="col-sm-8 col-xs-8">
          <ul><li><FormatMessage locale={this.props.locale} path="compliancePage/customerList1" /></li>
            <li><FormatMessage locale={this.props.locale} path="compliancePage/customerList2" /></li>
            <li><FormatMessage locale={this.props.locale} path="compliancePage/customerList3" /></li>
          </ul><br /><br />
        </div>
      </div>
      <FormatMessage locale={this.props.locale} path="compliancePage/customerDescription3" /><br /><br />
    </div>
  }
});

var BfgFileACompliant = React.createClass({

  render: function () {
    var message = "";

    if (this.props.locale == 'en') {
      message = <SectionList locale={this.props.locale} />;
    }
    console.log("locale", this.props.locale)
    return (

      <div className="container" id="terms-cond-div" style={{ "marginTop": "5%", "marginBottom": "5%" }}>
        <div className="row" style={{ "marginTop": "3%", "marginBottom": "2%" }}>

          <h3 className="text-center">
            <FormatMessage locale={this.props.locale} path="footer/footerCompliant" />
          </h3>

          <hr className="small-blue" />
        </div>

        <div className="col-xs-12 col-md-12 col-lg-12">
          <p>
            {
              this.props.locale == 'en' ?
                <div>
                  <p>To file a complaint, please contact Barri Money Services, LLC Customer Service before contacting your jurisdiction with a complaint.</p>
                  <p>Listed below are several ways to contact Barri Money Services, LLC Customer Service</p>
                  <p>&nbsp;</p>
                  <p>Phone:</p>
                  <p>Barri Money Services, LLC Customer Service al 1- 800-926-2277</p>
                  <p>&nbsp;</p>
                  <p>Write:</p>
                  <p>Barri Money Services, LLC</p>
                  <p>10777 Westheimer Road, Suite 1040</p>
                  <p>Houston,TX 77042, USA.</p>
                  <p>&nbsp;</p>
                  <p>Email:</p>
                  <p><a href="mailto:complaints@barri.com">complaints@barri.com</a></p>
                  <p>&nbsp;</p>
                  <p>After first contacting Barri Money Services, LLC, if you still have an unresolved complaint regarding the company's money transmission services, please review on the jurisdiction info below and direct your complaint to the appropriate contact &nbsp;or you may submit a complaint with the CFPB online (<a href="http://www.consumerfinance.gov/" target="_blank">http://www.consumerfinance.gov/</a>) or by calling&nbsp;<a href="tel:+18554112372">11 (855) 411-CFPB (2372)</a>.&nbsp;</p>
                </div>
                :
                <div>
                  <p>Para presentar un reclamo, comun&iacute;quese con el Servicio de atenci&oacute;n al cliente de Barri Money Services, LLC antes de comunicarse con su jurisdicci&oacute;n con una queja.</p>
                  <p>A continuaci&oacute;n se enumeran varias formas de comunicarse con el Servicio de atenci&oacute;n al cliente de Barri Money Services, LLC</p>
                  <p>&nbsp;</p>
                  <p>Tel&eacute;fono:&nbsp;</p>
                  <p>Barri Money Services, LLC Servicio al cliente al 1-800-926-2277</p>
                  <p>&nbsp;</p>
                  <p>Carta:</p>
                  <p>Barri Money Services, LLC</p>
                  <p>10777 Westheimer Road, Suite 1040 </p>
                  <p>Houston,TX 77042, USA.</p>
                  <p>&nbsp;</p>
                  <p>Correo electr&oacute;nico:</p>
                  <p><a href="mailto:complaints@barri.com">complaints@barri.com</a></p>
                  <p>&nbsp;</p>
                  <p>Despu&eacute;s de comunicarse con Barri Money Services, LLC, si a&uacute;n tiene un reclamo sin resolver con respecto a los servicios de transmisi&oacute;n de dinero de la compa&ntilde;&iacute;a, revise la informaci&oacute;n de la jurisdicci&oacute;n desde donde realizo su envio la cual podra ver a continuaci&oacute;n y dirija su queja al contacto apropiado o&nbsp; puede presentar una queja ante la Oficina para la Protecci&oacute;n Financiera del Consumidor (Consumer Financial Protection Bureau, CFPB) en l&iacute;nea (<a href="http://www.consumerfinance.gov/" target="_blank">http://www.consumerfinance.gov/</a>) o llamando al&nbsp;<a href="tel:+18554112372">1 (855) 411-CFPB (2372)</a>.&nbsp;</p>
                </div>
            }
          </p>
          <hr className="small-blue" />
        </div>
        <div className="row text-justify">
          {this.renderComplaint()}
        </div>
      </div>
    )
  },

  renderComplaint: function () {
    return (
      <div className="col-xs-12 col-md-12 col-lg-12">
        <div className="row">
          <div className="col-xs-6 col-md-6 col-lg-offset-1 col-lg-5 ">
            <address>
              <strong>Alabama Customers:</strong><br />
              Alabama Securities Commission <br />
              <a href="http://www.asc.state.al.us" target="_blank">http://www.asc.state.al.us </a><br />
              Telephone number:  <br /> 800-222-1253
            </address>
          </div>
          <div className="col-xs-6 col-md-6 col-lg-5">
            <address style={{ "word-wrap": "break-word" }}>
              <strong>For Alaska Residents Only:</strong><br />
              If your issue is unresolved by Barri Money Services, LLC, 1-800- 926- 2277 (toll free), please submit formal complaints with the State of Alaska, Division of Banking & Securities.<br />
              Please download the form here: <br/>
              <a href="https://www.commerce.alaska.gov/web/portals/3/pub/DBSGeneralComplaintFormupdated.pdf" target="blank">https://www.commerce.alaska.gov/web/portals/3/pub/DBSGeneralComplaintFormupdated.pdf</a><br />
              Submit formal complaint form with supporting documents:<br />
              Division of Banking & Securities PO Box 110807 Juneau, AK  99811-0807  <br />
              If you are an Alaska resident with questions regarding formal complaints, please email us at dbs.licensing@alaska.gov or call Nine Zero Seven Four Six Five Two Five Two One <br />
            </address>
          </div>
        </div>

        <div className="row">
          <div className="col-xs-6 col-md-6 col-lg-offset-1 col-lg-5 ">
            <address>
              <strong>Arizona Customers: </strong><br />
              Arizona Department of Financial Institutions  <br />
              <a href="https://difi.az.gov/complaint" target="_blank">https://difi.az.gov/complaint</a> <br />
              Telephone number:  602-771-2800<br />
              Toll Free: 1-800-544-0708 <br />
              100 N 15th Avenue, Suite 261, Phoenix, AZ 85007
            </address>
          </div>
          <div className="col-xs-6 col-md-6 col-lg-5">
            <address>
              <strong>Arkansas Customers:</strong><br />
              Arkansas Securities Department  <br />
              <a href="http://www.securities.arkansas.gov" target="_blank">http://www.securities.arkansas.gov  </a><br />
              By email: ASDInfo@securities.arkansas.gov <br />
              By mail: 1 Commerce Way Ste. 402 Little 
              Rock, AR 72202 <br />
              Telephone: (501) 324-9260 <br />
              Facsimile: (501) 324-9268 <br />
              Hotline: (800) 981-4429
            </address>
          </div>
        </div>

        <div className="row">
          <div className="col-xs-6 col-md-6 col-lg-offset-1 col-lg-5 ">
            <address>
              <strong>California Customers:</strong><br />
              Department of Financial Protection and Innovation <br />
              Toll Free: 866-275-2677 / 916-327-7585<br />
              <strong>Online </strong>
              <a href="https://dfpi.ca.gov/submit-a-complaint/" target="blank">https://dfpi.ca.gov/submit-a-complaint/</a><br />
              By mail:  2101 Arena Blvd., Sacramento, CA 95834
            </address>
          </div>
          <div className="col-xs-6 col-md-6 col-lg-5">
            <address>
              <strong>Colorado Customers:</strong><br />
              Colorado Division of Banking <br />
              <b>By mail:</b> <br/>
              1560 Broadway, Ste. 975<br />
              Denver, Colorado 80202<br />
              <a href="https://banking.colorado.gov/industry/money-transmitters" target="blank">https://banking.colorado.gov/industry/money-transmitters</a> <br />
              Telephone: 303-894-7575 <br />
              <a href="/documents/CustomerNotice(MO7).pdf" target="blank">Colorado Consumer Complaint Notice</a> <br />
            </address>
          </div>
        </div>

        <div className="row">
          <div className="col-xs-6 col-md-6 col-lg-offset-1 col-lg-5 ">
            <address>
              <strong>Connecticut Customers:</strong><br />
              Connecticut Department of Banking<br />
              <a href="http://www.ct.gov/dob" target="blank">http://www.ct.gov/dob</a><br />
              Telephone: 1.800.831-7225<br />
            </address>
          </div>
          <div className="col-xs-6 col-md-6 col-lg-5">
            <address>
              <strong>Delaware Customers:</strong><br />
              Office of the State Bank Commissioner<br />
              <a href="https://banking.delaware.gov" target="blank">https://banking.delaware.gov</a><br />
              Telephone:  302)-739-4235, from 8:00 am to 4:30 pm Monday through Friday
              ,or call the State of Delaware Helpline, (800) 464-4357<br />
              Residents of New Castle County, Delaware may reach us by calling 577-6722<br />
              Many concerns can be addressed over the telephone, but complaints requiring investigation must
              be submitted in writing to:1110 Forrest Avenue  Dover, DE 19904, Attention: Compliance.<br />
              Written complaints can also be faxed to (302) 739-2356, or electronically mailed over the internet to Carole.Hoffecker@delaware.gov
            </address>
          </div>
        </div>

        <div className="row">
          <div className="col-xs-6 col-md-6 col-lg-offset-1 col-lg-5 ">
            <address>
              <strong>Florida Customers: </strong><br />
              Florida Office of Financial Regulation <br />
              <a href="http://www.flofr.com" target="_blank">http://www.flofr.com   </a> <br />
              Telephone number:  850-487-9687 <br />
              Toll-Free: 1-877-MY-FL-CFO (1-877-693-5236)
          </address>
          </div>
          <div className="col-xs-6 col-md-6 col-lg-5">
            <address>
              <strong>Georgia Customers: </strong><br />
              Georgia Department of Banking & Finance <br />
              <a href="http://www.dbf.georgia.gov" target="_blank"> http://www.dbf.georgia.gov </a><br />
              Toll-Free: (888) 986-1633 <br />
            </address>
          </div>
        </div>

        <div className="row">
          <div className="col-xs-6 col-md-6 col-lg-offset-1 col-lg-5 ">
            <address>
              <strong>Idaho Customers:</strong><br />
              Department of Finance<br />
              <a href="https://www.finance.idaho.gov" target="blank">https://www.finance.idaho.gov</a><br />
              Telephone number:<br />
              208-332-8000<br />
              Toll-Free (Idaho Only): 1-888-346-3378
            </address>
          </div>
          <div className="col-xs-6 col-md-6 col-lg-5">
            <address>
              <strong>Illinois Customers: </strong><br />
              Illinois Department of Financial and Professional Regulation <br />
              <a href="http://www.idfpr.com" target="_blank">http://www.idfpr.com </a> <br />
              Telephone number: <br />
              888-473-4858
            </address>
          </div>
        </div>

        <div className="row">
          <div className="col-xs-6 col-md-6 col-lg-offset-1 col-lg-5 ">
            <address>
              <strong>Indiana Customers:</strong><br />
              Indiana Department of Financial Institutions<br />
              <a href="https://www.in.gov/dfi" target="blank">https://www.in.gov/dfi</a><br />
              Telephone number:<br />
              1.800.382.4880<br />
              <strong>Email:</strong><br />
              dficomplaints@dfi.in.gov
            </address>
          </div>
          <div className="col-xs-6 col-md-6 col-lg-5">
            <address>
              <strong>Iowa Customers:</strong><br />
              Iowa Division of Banking Finance Bureau<br />
              <a href="https://www.idob.state.ia.us/public/contactInfo/contactForm.aspx?type=complaint" target="blank">https://www.idob.state.ia.us</a><br />
              Telephone number:<br />
              515-281-4014<br />
            </address>
          </div>
        </div>

        <div className="row">
          <div className="col-xs-6 col-md-6 col-lg-offset-1 col-lg-5 ">
            <address>
              <strong>Kansas Customers: </strong><br />
              Kansas Office of the State Bank Commissioner <br />
              <a href="http://www.osbckansas.org" target="_blank"> http://www.osbckansas.org </a><br />
              Telephone number:  <br />
              785-296-2266
            </address>
          </div>
          <div className="col-xs-6 col-md-6 col-lg-5">
            <address>
              <strong>Kentucky Customers:</strong><br />
              Kentucky Department of Financial Institutions  <br />
              <a href="http://kfi.ky.gov " target="blank">http://kfi.ky.gov </a><br />
              Telephone number:<br />
              844-354-0613 <br />
              502-573-3390 <br />
              Toll Free:  1 800-223-2579 <br />
              Fax:  1 502-573-0086
            </address>
          </div>
        </div>

        <div className="row">
          <div className="col-xs-6 col-md-6 col-lg-offset-1 col-lg-5 ">
            <address>
              <strong>Louisiana Customers: </strong><br />
              All complaints must be submitted in writing <br />
              to Louisiana Office of Financial  <br />
              Institutions by mail, email, or fax. <br />
              By Mail:  Office of Financial Institutions Post  <br />
              Office Box 94095 Baton Rouge, LA  70804-9095 <br />
              By Email: complaints@ofi.la.gov <br />
              Fax: (225) 925-4524 <br />
              Telephone number: (225) 925-4660 <br />
              Toll Free 888-525-9414 <br />
              <a href="http://www.ofi.louisiana.gov" target="_blank">http://www.ofi.louisiana.gov </a> <br />
            </address>
          </div>
          <div className="col-xs-6 col-md-6 col-lg-5">
            <address style={{ "word-wrap": "break-word" }}>
              <strong>Maine Customers:</strong><br />
              Department of Professional & Financial Regulation <br />
              Bureau of Consumer Credit Protection<br />
              <a href="https://www.maine.gov/pfr/consumercredit/complaint.htm" target="blank">https://www.maine.gov/pfr/consumercredit/complaint.htm</a><br />
              Telephone number: 800-DEBT LAW (800-332-8529)<br />
              Toll-Fre: 800-DEBT LAW (800-332-8529) <br />
              35 State House Station, Augusta, Maine 04333<br />
            </address>
          </div>
        </div>

        <div className="row">
          <div className="col-xs-6 col-md-6 col-lg-offset-1 col-lg-5 ">
            <address>
              <strong>Maryland Customers:</strong><br />
              <a href="https://www.dllr.state.md.us" target="blank">https://www.dllr.state.md.us</a><br />
              Office of the Commissioner of Financial Regulation <br />
              Maryland Department of Labor <br />
              500 North Calvert St., Suite 402 <br />
              Baltimore, MD 21202 <br />
              Telephone: 1-888-784-0136 <br />
              <a href="http://www.dllr.state.md.us/finance" target="blank">http://www.dllr.state.md.us/finance</a><br />
              The Commissioner of Financial Regulation for the <br />
              State of Maryland will accept all questions or <br />
              complaints from Maryland residents regarding <br />
              Barri Money Services, LLC.<br />
              NMLS # 937962 at: 500 N Calvert Street, <br />
              Suite 402, Baltimore, Maryland, 21202,<br />
              phone toll free 888-784-0136.<br /><br />
              Barri Money Services, <br />
              LLC  license status information can be viewed on the <br />
              NMLS Consumer Access website at <br /><a href="https://nmlsconsumeraccess.org/" target="blank">https://nmlsconsumeraccess.org/</a><br />
            </address>
          </div>
          <div className="col-xs-6 col-md-6 col-lg-5">
            <address>
              <strong>Massachusetts Customers:</strong><br />
              Massachusetts Division of Banks  <br />
              <a href="https://www.mass.gov/orgs/division-of-banks" target="blank">https://www.mass.gov/orgs/division-of-banks</a><br />
              Telephone number:<br />
              Toll-Free at (800) 495-BANK (2265) <br />
            </address>
          </div>
        </div>

        <div className="row">
          <div className="col-xs-6 col-md-6 col-lg-offset-1 col-lg-5 ">
            <address>
              <strong>Michigan Customers: </strong><br />
              Michigan Department of Insurance & Financial Services <br />
              <a href="https://www.michigan.gov/difs/consumers/complaint" target="_blank">https://www.michigan.gov/difs/consumers/complaint</a><br />
              Telephone number:  <br />
              877-999-6442
            </address>
          </div>
          <div className="col-xs-6 col-md-6 col-lg-5">
            <address>
              <strong>Minnesota Customers:</strong><br />
              Minnesota Department of Commerce<br />
              <a href="https://mn.gov/commerce/consumers" target="blank">https://mn.gov/commerce/consumers</a><br />
              Telephone:  (Local) 651-539-1500<br />
              (Complaints) 651-539-1600<br />
              By mail:  Main Office, Golden Rule Building, <br />
              85 7th Place East Suite 280 Saint Paul, Minnesota 55101
            </address>
          </div>
        </div>

        <div className="row">
          <div className="col-xs-6 col-md-6 col-lg-offset-1 col-lg-5 ">
            <address>
              <strong>Mississippi Customers: </strong><br />
              Mississippi Department of Banking & Consumer Finance <br />
              <a href="http://www.dbcf.state.ms.us" target="_blank">http://www.dbcf.state.ms.us </a> <br />
              Telephone number:
              800-844-2499 <br />
              Toll Free: 1-800-844-2499
            </address>
          </div>
          <div className="col-xs-6 col-md-6 col-lg-5">
            <address>
              <strong>Missouri Customers:</strong><br />
              Division of Finance<br />
              Truman State Office Building <br />
              <a href="https://finance@dof.mo.gov" target="blank">https://finance@dof.mo.gov</a><br />
              Telephone number:<br />
              (573) 751-3242 <br />
              (573) 751-9192 (fax) <br />
              <strong>E-mail:</strong><br />
              finance@dof.mo.gov
            </address>
          </div>
        </div>

        <div className="row">
          <div className="col-xs-6 col-md-6 col-lg-offset-1 col-lg-5 ">
            <address>
              <strong>Montana Customers:</strong><br />
              For consumers located in Montana,<br /> please contact Barri Money Services, LLC directly
            </address>
          </div>
          <div className="col-xs-6 col-md-6 col-lg-5">
            <address>
              <strong>North Carolina Customers: </strong><br />
              North Carolina Office of the Commissioner of Banks  <br />
              <a href="http://www.nccob.gov/public/" target="_blank">http://www.nccob.gov/public/ </a> <br />
              Telephone number: <br />
              1-800-874-9791 <br />
              1-919-733-3016
            </address>
          </div>
        </div>

        <div className="row">
          <div className="col-xs-6 col-md-6 col-lg-offset-1 col-lg-5 ">
            <address>
              <strong>North Dakota:</strong><br />
              ND Dept. of Financial Institutions Consumer Division <br />
              <a href="https://www.nd.gov/dfi" target="blank">https://www.nd.gov/dfi</a><br />
              Telephone number:<br />
              (701) 328-9933 <br />
            </address>
          </div>
          <div className="col-xs-6 col-md-6 col-lg-5">
            <address>
              <strong>Nebraska Customers:</strong><br />
              Nebraska Department of Banking and Finance<br />
              <a href="http://www.ndbf.ne.gov/" target="blank">http://www.ndbf.ne.gov/</a><br />
              Telephone number: (402) 471-2171<br />
              Consumer Hotline: (877) 471-3445<br />
              1526 K St #300, Lincoln, NE 68508
            </address>
          </div>
        </div>

        <div className="row">
          <div className="col-xs-6 col-md-6 col-lg-offset-1 col-lg-5 ">
            <address>
              <strong>Nevada Customers:</strong><br />
              Nevada Financial Institutions Division<br />
              702-486-4120<br />
              <a href="https://fid.nv.gov/" target="blank">https://fid.nv.gov/</a>
            </address>
          </div>
          <div className="col-xs-6 col-md-6 col-lg-5">
            <address>
              <strong>New Hampshire Customers:</strong><br />
              State of New Hampshire Banking Department <br />
              53 Regional Drive, Suite 200, Concord NH 03301<br />
              Telephone: (603) 271-3561<br />
              TDD Access: Relay NH 1-800-735-2964<br />
              Fax: (603) 271-1090<br />
              <strong>E-mail </strong>
              legal@banking.nh.gov <br />
            </address>
          </div>
        </div>

        <div className="row">
          <div className="col-xs-6 col-md-6 col-lg-offset-1 col-lg-5">
            <address>
              <strong>New Jersey Customers:</strong><br />
              New Jersey Department of Banking and Insurance<br />
              609-292-7272<br />
              <a href="https://www.nj.gov/dobi/index.html" target="blank">https://www.nj.gov/dobi/index.html</a>
            </address>
          </div>
          <div className="col-xs-6 col-md-6 col-lg-5">
            <address>
              <strong>New Mexico Customers: </strong><br />
              New Mexico Financial Institutions Division <br />
              <a href="http://www.rld.state.nm.us" target="_blank">http://www.rld.state.nm.us </a><br />
              Telephone number:  <br />
              505-476-4885
            </address>
          </div>
        </div>

        <div className="row">
          <div className="col-xs-6 col-md-6 col-lg-offset-1 col-lg-5">
            <address>
              <strong>New York Customers:</strong><br />
              New York State Department of Financial Services<br />
              1-800-342-3736<br />
              <a href="https://www.dfs.ny.gov/complaint" target="blank">https://www.dfs.ny.gov/complaint</a>
            </address>
          </div>
          <div className="col-xs-6 col-md-6 col-lg-5">
            <address>
              <strong>Ohio Customers:</strong><br />
              Ohio Division of Financial Institutions<br />
              <a href="https://www.com.ohio.gov" target="blank">https://www.com.ohio.gov</a><br />
              Telephone number:<br />
              1-866-278-0003<br />
              614/728-8400
            </address>
          </div>
        </div>

        <div className="row">
          <div className="col-xs-6 col-md-6 col-lg-offset-1 col-lg-5 ">
            <address>
              <strong>Oklahoma Customers: </strong><br />
              Oklahoma Banking Department <br />
              <a href="http://www.ok.gov/banking/" target="_blank">http://www.ok.gov/banking/ </a><br />
              Telephone number:  <br />
              405-521-2782
            </address>
          </div>
          <div className="col-xs-6 col-md-6 col-lg-5">
            <address>
              <strong>Oregon Costumers:</strong><br />
              Oregon Division of Financial Regulation <br />
              <a href="https://dfr.oregon.gov/help/complaints" target="blank">https://dfr.oregon.gov/help/complaints</a> <br />
              Email: DFR.FinancialServicesHelp@oregon.gov<br />
              Telephone number: 888-877-4894 (toll-free)<br />
              By mail: PO Box 14480 Salem, OR 97309-0405 <br />
              Fax: 503-378-4351 <br />
            </address>
          </div>
        </div>

        <div className="row">
          <div className="col-xs-6 col-md-6 col-lg-offset-1 col-lg-5 ">
            <address>
              <strong>Pennsylvania Customers:</strong><br />
              Pennsylvania Department of Banking and Securities<br />
              <a href="https://www.dobs.pa.gov/Consumers/Pages/File-a-Complaint.aspx" target="blank">https://www.dobs.pa.gov/Consumers/Pages/File-a-Complaint.aspx</a><br />
              Telephone:  1.800.PA.BANKS (1.800.722.2657)<br />
              17 N. 2nd Street, Suite 1300, Harrisburg, PA 17101
            </address>
          </div>
          <div className="col-xs-6 col-md-6 col-lg-5">
            <address>
              <strong>Puerto Rico Customers:</strong><br />
              Puerto Rico Office of Commissioner of Financial Institutions<br />
              Telephone: 800-981-7711<br />
              <a href=" http://www.ocif.pr.gov" target="blank"> http://www.ocif.pr.gov</a><br />
            </address>
          </div>
        </div>

        <div className="row">
          <div className="col-xs-6 col-md-6 col-lg-offset-1 col-lg-5 ">
            <address>
              <strong>Rhode Island Customers:</strong><br />
              Department of Business Regulation<br />
              <a href="http://www.dbr.ri.gov/divisions/banking" target="blank">http://www.dbr.ri.gov/divisions/banking</a><br />
              Telephone number:<br />
              (401) 462-9500
            </address>
          </div>
          <div className="col-xs-6 col-md-6 col-lg-5">
            <address>
              <strong>South Carolina Customers: </strong><br />
              State Board of Financial Institutions Consumer  <br />
              Finance Division <br />
              <a href="http://bofi.sc.gov/ConsumerFinance" target="_blank">http://bofi.sc.gov/ConsumerFinance </a> <br />
              Telephone number: <br />
              (803)734-2020 <br />
            </address>
          </div>
        </div>

        <div className="row">
          <div className="col-xs-6 col-md-6 col-lg-offset-1 col-lg-5 ">
            <address>
              <strong>South Dakota Customers:</strong><br />
              South Dakota Division of Banking<br />
              <a href="https://dlr.sd.gov/banking" target="blank">https://dlr.sd.gov/banking</a><br />
              Telephone:  605.773.3421<br />
              Fax:  866.326.7504<br />
              1601 N. Harrison Avenue, Suite 1 Pierre, SD 57501
            </address>
          </div>
          <div className="col-xs-6 col-md-6 col-lg-5">
            <address>
              <strong>Tennessee Customers: </strong><br />
              Department of Financial Institutions <br />
              <a href="http://www.tennessee.gov/tdfi/" target="_blank">http://www.tennessee.gov/tdfi/ </a><br />
              Telephone number:
              (615) 741-2236 <br />
              1-800-778-4215 <br />
              <strong>E-mail </strong>
              TDFI.Contact@tn.gov
            </address>
          </div>
        </div>

        <div className="row">
          <div className="col-xs-6 col-md-6 col-lg-offset-1 col-lg-5 ">
            <address>
              <strong>Texas Customers: </strong><br />
              Texas Department of Banking <br />
              <strong>Non Depository Supervision Division</strong><br />
              <a href="http://www.dob.texas.gov/" target="_blank">http://www.dob.texas.gov/ </a> <br />
              Telephone number: <br />
              877-276-5554 (toll free) <br />
              <strong>By mail: </strong><br />
              Texas Department of Banking <br />
              2601 North Lamar Boulevard <br />
              Austin, Texas 78705
            </address>
          </div>
          <div className="col-xs-6 col-md-6 col-lg-5">
            <address>
              <strong>Utah Customers:  </strong><br />
              Utah Department of Financial Institutions <br />
              <a href="http://www.dfi.utah.gov/" target="_blank">http://www.dfi.utah.gov/</a> <br />
              Telephone number: <br />
              801-538-8830
            </address>
          </div>
        </div>

        <div className="row">
          <div className="col-xs-6 col-md-6 col-lg-offset-1 col-lg-5 ">
             <address>
              <strong>US Virgin Islands Customers:  </strong><br />
              Office of the Lieutenant Governor<br />
              Division of Banking, Insurance and Financial Regulation <br />
              340-774-2991<br />
              <a href="https://ltg.gov.vi" target="_blank">https://ltg.gov.vi</a>
            </address>
          </div>
          <div className="col-xs-6 col-md-6 col-lg-5">
           <address>
              <strong>Virginia Customers:</strong><br />
              State Corporation Commission<br />
              Virginia Bureau of Financial Institutions<br />
              804-371-9701<br />
              <a href="http://www.scc.virginia.gov/bfi" target="blank">http://www.scc.virginia.gov/bfi</a>
            </address>
          </div>
        </div>
        
        <div className="row">
          <div className="col-xs-6 col-md-6 col-lg-offset-1 col-lg-5 ">
            <address>
              <strong>Vermont Customers:</strong><br />
              Vermont Department of Financial Regulation   <br />
              Banking Division <br />
              <a href="https://dfr.vermont.gov" target="blank">https://dfr.vermont.gov</a><br />
              Telephone number:<br />
              (888) 568-4547 call free/ llamada gratuita <br />
              <strong>E-mail:</strong><br />
              dfr.bnkconsumer@vermont.gov
            </address>
          </div>
          <div className="col-xs-6 col-md-6 col-lg-5">
            <address>
              <strong>Washington Customers:</strong><br />
              Washington Department of Financial Institutions <br />
              <a href="https://dfi.wa.gov" target="blank">https://dfi.wa.gov</a><br />
              Telephone number:<br />
              (360) 902-8703 <br />
              1-877-RING DFI (1-877-746-4334) <br />
              <strong>E-mail:</strong><br />
              CSEnforceComplaints@dfi.wa.gov
            </address>
          </div>
        </div>

        <div className="row">
          <div className="col-xs-6 col-md-6 col-lg-offset-1 col-lg-5 ">
            <address>
              <strong>West Virginia Customers:</strong><br />
              West Virginia Division of Financial Institutions<br />
              <a href="www.dfi.wv.gov" target="blank">www.dfi.wv.gov</a><br />
              Telephone: (304) 558-2294<br />
              Fax (304) 558-0442<br />
            </address>
          </div>
          <div className="col-xs-6 col-md-6 col-lg-5">
            <address>
              <strong>Wisconsin Costumers:</strong><br />
              Wisconsin Department of Financial Institutions<br />
              4822 Madison Yards Way, North Tower<br />
              Madison, WI 53705<br />
              Telephone: 608-261-9555 <br />
              <a href="http://www.wdfi.org" target="blank">http://www.wdfi.org</a><br />
            </address>
          </div>
        </div>

        <div className="row">
          <div className="col-xs-6 col-md-6 col-lg-offset-1 col-lg-5 ">
            <address>
              <strong>Wyoming Customers:</strong><br />
              Department of Audit <br />
              Division of Banking <br />
              <a href="http://wyomingbankingdivision.wyo.gov" target="blank">http://wyomingbankingdivision.wyo.gov</a><br />
              Telephone number:<br />
              (307) 777-7797 <br />
            </address>
          </div>
          <div className="col-xs-6 col-md-6 col-lg-5">
            
          </div>
        </div>
        
      </div>
    )
  },
});


module.exports = BfgFileACompliant



// WEBPACK FOOTER //
// ./js/FileaCompliant.js